module.exports = __webpack_public_path__ + "img/20220624171957.a658b705.png";